import { KMSClient, DecryptCommand } from '@aws-sdk/client-kms';
import { fromBase64 } from '@aws-sdk/util-base64-browser';
import envConfig from 'env/EnvConfig';
import { getKmsCredentials } from './aws-kms-credentials';

const awsKey = envConfig.AWS_KMS_KEY;
const region = envConfig.AWS_PROJECT_REGION;

let _kmsClient = null;
let _kmsClientKey = '';

function getKMSClient(credentials) {
  const key = `${credentials.accessKeyId}:${credentials.sessionToken || ''}`;
  
  if (_kmsClient && _kmsClientKey === key) {
    return _kmsClient;
  }

  _kmsClient = new KMSClient({
    region,
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    }
  });
  
  _kmsClientKey = key;
  return _kmsClient;
}

async function decrypt(inputData) {
  if (!inputData) {
    return null;
  }

  const kmsCredentials = await getKmsCredentials();
  
  if (!kmsCredentials?.accessKeyId || !kmsCredentials?.secretAccessKey) {
    throw new Error('No AWS credentials from Amplify. Ensure Amplify.configure has run and Auth.Cognito.identityPoolId is set. If using authenticated creds, call after sign-in.');
  }

  const kms = getKMSClient(kmsCredentials);
  
  // Convert base64 string to Uint8Array
  const ciphertextBlob = Uint8Array.from(atob(inputData), c => c.charCodeAt(0));
  
  const params = {
    KeyId: awsKey,
    EncryptionAlgorithm: 'SYMMETRIC_DEFAULT',
    CiphertextBlob: ciphertextBlob
  };

  try {
    const command = new DecryptCommand(params);
    const response = await kms.send(command);
    
    // Convert Uint8Array to string
    return new TextDecoder().decode(response.Plaintext);
  } catch (error) {
    console.error('Error decrypting data:', error);
    throw error;
  }
}

export default decrypt;